<script>
import vue2Dropzone from "vue2-dropzone";
import {
  productService,
  categoryService,
  customerService,
} from "../../services";
import { required, requiredIf } from "vuelidate/lib/validators";
import config from "../../config";
import {
  error_message,
  success_message,
  get_decimal,
  validate_decimal_input,
  validate_three_decimal_input,
  validate_four_decimal_input
} from "../../Helper/helper";
import { findUserById, convertUnits } from "../../Helper/product";
import DropzonePopup from "../../components/widgets/dropzone-popup";
import DatePicker from "vue2-datepicker";
import Layout from "../../layouts/main";
import PageHeader from "../../components/page-header";
import "vue2-datepicker/index.css";
import { routes } from "../../config/api_routes";
import {
  numberLength,
  decimalNumber,
  NotZeroNumber,
} from "../../Helper/formValidation";
import Multiselect from "vue-multiselect";

export default {
  components: {
    vueDropzone: vue2Dropzone,
    DropzonePopup,
    productService,
    customerService,
    DatePicker,
    Layout,
    PageHeader,
    Multiselect,
  },
  data() {
    return {
      url: null,
      config: config,
      tags: [],
      prices: [],
      customers: [],
      error: [],
      reusable: "",
      discount: "",
      discount_type: "",
      item_type: "",
      showTimeRangePanel: false,
      rangeSeparator: "-",
      format: "YYYY/MM/DD HH:s",
      attrName: { material: [], size: [] },
      product_vat: "",
      product_unit_sign: "",
      item_vat: "",
      decimal: get_decimal(),
      isDisabled: false,
      // b2b_customer_chk:[],
      typeform: {
        id: "",
        product_id: this.$route.params.product_id,
        sub_product_name: "",
        sub_product_name_lang: "",
        image: [],
        tag_id: 0,
        quantity: "",
        per_unit_price: "",
        per_unit_price_business: "",
        per_unit_dis_price: "",
        per_unit_dis_price_business: "",
        sale_price: "",
        business_sale_price: "",
        selling_qty: "",
        price: 0,
        business_customer_price: 0,
        is_discount: 0,
        customer_dis_type: "0",
        dis_price: "",
        business_dis_price: "",
        is_reusable: "",
        start_datetime: "",
        end_datetime: "",
        attributes: {},
        datetime: "",
        product_box_type: "",
        refund_price: "",
        half_refund_price: "",
        single_refund_price: "",
        product_number: "",
        barcode_number: "",
        product_type: "",
        single_product_price: "",
        status: "",
        // b2b_customers: [],
      },
      // b2b_customers: {
      //   customer: "",
      //   min_qty: 1,
      //   price: "",
      //   per_unit_price: "",
      // },
      image_name: [],
      image_media_path: "",
      image_delete_url: routes.subImageDeleteUrl,
      barcode_name: "",
      barcode_media_path: "",
    };
  },
  validations: {
    typeform: {
      image: {
        required: requiredIf(function (nestedModel) {
          return !(!!this.image_name || !!this.typeform.image);
        }),
      },
      quantity: {
        required,
      },
      product_type: {
        required,
      },
      per_unit_price: {
        required,
      },
      per_unit_price_business: {
        required,
      },
      price: {
        required,
      },
      business_customer_price: {
        required,
      },
      attributes: {
        material: { required },
        size: { required },
      },
      product_box_type: {
        // required: requiredIf(function (form) {
        //   return this.selling_qty > 1 || this.item_type == 1;
        // }),
      },
      sale_price: {
        required,
      },
      business_sale_price: {
        required,
      },
      selling_qty: {
        required: requiredIf(function (form) {
          return this.item_type == 1;
        }),
      },
      // single_product_price: {
      //   required: requiredIf(function (form) {
      //     return this.item_type == 1;
      //   }),
      // },
      customer_dis_type: {
        required: requiredIf(function (form) {
          return this.discount == 1;
        }),
      },
      dis_price: {
        required: requiredIf(function (form) {
          return (
            this.discount == 1 &&
            (this.discount_type == 2 || this.discount_type == 0)
          );
        }),
      },
      business_dis_price: {
        required: requiredIf(function (form) {
          return (
            this.discount == 1 &&
            (this.discount_type == 1 || this.discount_type == 0)
          );
        }),
      },
      datetime: {
        required: requiredIf(function (form) {
          return this.discount == 1;
        }),
      },
      product_number: {
        required,
      },
      barcode_number: {
        required,
      },
      // b2b_customers: {
      //   $each: {
      //     customer: {
      //       // required: requiredIf(function (form) {
      //       //   return form.price != "";
      //       // }),
      //     },
      //     min_qty: {
      //       required: requiredIf(function (form) {
      //         return form.customer != "" || form.price != "";
      //       }),
      //     },
      //     price: {
      //       required: requiredIf(function (form) {
      //         return form.customer != "";
      //       }),
      //     },
      //   },
      // },
    },
  },
  mounted() {
    this.getAttribute();
    this.getProductTag();
    this.getProductBox();
    this.getSubProductById();
    this.getRefundPrice();
    // this.asyncFindCustomer({ search: "" });
  },
  methods: {
    numberLength,
    decimalNumber,
    NotZeroNumber,
    onTypeChange() {
      this.reusable = this.typeform.is_reusable;
    },
    onDiscountChange() {
      this.discount = this.typeform.is_discount;
    },
    onRoleChange() {
      this.discount_type = this.typeform.customer_dis_type;
    },
    disabledBeforeTodayAndAfterAWeek(date) {
      return date < new Date(new Date().setHours(0, 0, 0, 0));
    },
    toggleTimeRangePanel() {
      this.showTimeRangePanel = !this.showTimeRangePanel;
    },
    handleRangeClose() {
      this.showTimeRangePanel = false;
    },
    validatePrivatePrice(value) {
      // fattehali comment code
      // this.typeform.price = validate_decimal_input(value);
      // fattehali comment code

      // fattehali code
      this.typeform.price = validate_four_decimal_input(value);
      // fattehali code
      
    },

    validatePrivateSalePrice(value) {
      this.typeform.dis_price = validate_four_decimal_input(value);
    },

    validateBusinessPrice(value) {
      // fattehali comment code
      // this.typeform.business_customer_price = validate_decimal_input(value);
      // fattehali comment code
      
      // fattehali code
      this.typeform.business_customer_price = validate_four_decimal_input(value);
      // fattehali code
    },

    validateBusinessSalePrice(value) {
      this.typeform.business_dis_price = validate_four_decimal_input(value);
    },
    floatingNumber(e) {
      const floating = /^[0-9.]\d*(\.\d{1,2})?$/;
      let char = String.fromCharCode(e.keyCode);
      if (floating.test(char)) return true;
      else e.preventDefault();
    },
    contactNumber(evt) {
      let val1 = evt.target.value;
      if ((evt.keyCode == 118 && val1.length <= 13) || evt.keyCode == 99) {
        return evt.target.value;
      }

      if (!(evt.keyCode == 43 || (evt.keyCode >= 48 && evt.keyCode <= 57))) {
        evt.preventDefault();
      }

      if (
        evt.keyCode == 43 &&
        evt.target.selectionStart !== undefined &&
        evt.target.selectionStart !== 0
      ) {
        evt.preventDefault();
      }
      return evt.target.value;
    },
    onImagedeleted(value) {
      this.image_name = this.image_name.filter((doc) => doc.image !== value);
    },
    onProductImagedeleted(value) {
      this.image_name = "";
    },
    onBarcodedeleted(value) {
      this.barcode_name = "";
    },
    onItemChange() {
      if (this.typeform.product_type == 0) {
        this.typeform.selling_qty = 1;
      }
      this.item_type = this.typeform.product_type;
      this.changePerUnitPrice("");
    },
    // checkCustomer(val, i) {
    //   var id = val.user_id;
    //   let chk = this.b2b_customer_chk.findIndex((data) => data == id);
    //   this.error[i] = false;
    //   if(chk == -1){
    //     if(this.b2b_customer_chk[i] != ''){
    //       this.b2b_customer_chk.splice(i,1,id);
    //     }else{
    //       this.b2b_customer_chk.push(id);
    //     }
    //   }else{
    //     this.error[i] = true;
    //     return false;
    //   }
    //   // this.typeform.b2b_customers.forEach((item,key)=>{
    //   //   let chk  = this.b2b_customer_chk.find((data)=>{
    //   //     return data == id;
    //   //   });
    //   //   console.log(chk);
    //   //   if(chk != ''){
    //   //     this.b2b_customer_chk.push(id);
    //   //   }else{
    //   //     this.error[i] = true;
    //   //     return 
    //   //   }
    //   // });
    //   if(this.error[i] == true){
    //     return false;
    //   }
    //   // console.log('val',val);
    //   // console.log('this.typeform.b2b_customers',this.typeform.b2b_customers);
    //   // var customer = this.typeform.b2b_customers.filter(function (elem) {
    //   //   if (elem.customer.user_id == id ) return elem;
    //   // });

    //   // if(i != 0){  // first time not check
    //   //   this.error[i] = false;
    //   //   if (customer.length > 0) {
    //   //     this.error[i] = true;
    //   //     return false;
    //   //   }
    //   // }
    // },
    getSubProductById() {
      productService
        .getSubProductById({ id: this.$route.params.id, type: "get" })
        .then((response) => {
          const {
            id,
            product_id,
            sub_product_name,
            sub_product_name_lang,
            quantity,
            sale_price,
            business_sale_price,
            selling_qty,
            is_discount,
            customer_dis_type,
            dis_price,
            business_dis_price,
            is_barcode,
            start_datetime,
            end_datetime,
            product_number,
            barcode_number,
            product_type,
            // single_product_price,
            price,
            business_customer_price,
            status,
            product,
          } = response.data.result.data;

          var attributes = {};
          attributes.material = response.data.result.attributes.material_data;
          attributes.size = response.data.result.attributes.size_data;

          this.product_vat = response.data.result.data.product.vat.vat;
          this.product_unit_sign =
            response.data.result.data.product.product_unit_sign;

          // var b2b_customers = [];
          // if (response.data.result.b2b_customers.length == 0) {
          //   b2b_customers.push({
          //     customer: "",
          //     min_qty: 1,
          //     price: "",
          //     per_unit_price: "",
          //   });
          // } else {
          //   b2b_customers = response.data.result.b2b_customers;

          //   // B2B client add 
          //   response.data.result.b2b_customers.forEach((item,key)=>{
          //     if(item.customer){
          //       this.b2b_customer_chk.push(item.customer.user_id);
          //       this.error[key] = false;
          //     }
          //   });
          //   // B2B client add 
          // }

          const is_reusable = response.data.result.data.is_reusable ?? "";
          const product_box_type =
            response.data.result.data.product_box_type ?? "";
          // const half_refund_price =
          //   response.data.result.data.half_refund_price ?? "";
          const single_refund_price = response.data.result.data.single_bottle_return ?? "";
          const refund_price = response.data.result.data.refund_price ?? "";
          const tag_id = response.data.result.data.tag_id ?? 0;

          this.typeform = {
            id,
            product_id,
            sub_product_name,
            sub_product_name_lang,
            tag_id,
            quantity,
            sale_price,
            business_sale_price,
            selling_qty,
            is_discount,
            customer_dis_type,
            dis_price,
            business_dis_price,
            is_reusable,
            start_datetime,
            end_datetime,
            product_box_type,
            refund_price,
            // half_refund_price,
            single_refund_price,
            product_number,
            barcode_number,
            is_barcode,
            product_type,
            // single_product_price,
            attributes,
            status,
            price,
            business_customer_price,
            // b2b_customers,
          };

          this.image_name = response.data.result.data.product_image;
          this.image_media_path = response.data.result.data.image_media_path;
          this.barcode_name = response.data.result.data.barcode_image;
          this.barcode_media_path =
            response.data.result.data.barcode_media_path;
          this.discount_type = this.typeform.customer_dis_type;
          this.reusable = this.typeform.is_reusable;
          this.discount = this.typeform.is_discount;
          this.item_type = this.typeform.product_type;
          this.typeform.datetime =
            response.data.result.data.datetime != ""
              ? response.data.result.data.datetime.split(" - ")
              : "";
          this.typeform.per_unit_price =
            response.data.result.data.per_unit_price;
          this.typeform.per_unit_price_business =
            response.data.result.data.per_unit_price_business;
          this.typeform.per_unit_dis_price =
            response.data.result.data.per_unit_dis_price;
          this.typeform.per_unit_dis_price_business =
            response.data.result.data.per_unit_dis_price_business;

          this.calFullRefundPrice();
        });
    },
    getAttribute() {
      categoryService.getAttribute().then((response) => {
        this.attrName = response.data.result;
        this.attrName.material = response.data.result.material.sort((a, b) => {
            return a.att_name.localeCompare(b.att_name);
        });
        this.attrName.size = response.data.result.size.sort((a, b) => {
            return a.att_name.localeCompare(b.att_name);
        });
      });
    },
    getProductTag() {
      productService.getProductTag().then((response) => {
        this.tags = response.data.result;
      });
    },
    getProductBox() {
      productService.getProductBox().then((response) => {
        this.boxes = response.data.result;
      });
    },
    // asyncFindCustomer(query) {
    //   this.isLoading = true;
    //   customerService
    //     .getCustomerTypeList({ type: "5", query })
    //     .then((response) => {
    //       const cust = response.data.result.filter((item,key)=>{
    //         return response.data.result[key]['name'] = item.name + ' (' +item.company_details.name + ')';
    //       }).sort((a, b) => a.name.localeCompare(b.name));
    //       this.customers = cust;
    //       this.isLoading = false;
    //     });
    // },
    // AddField: function () {
    //   this.typeform.b2b_customers.push({
    //     customer: "",
    //     min_qty: 1,
    //     price: "",
    //     per_unit_price: "",
    //   });
    // },
    // remove_field(index) {
    //   this.typeform.b2b_customers.splice(index, 1);
    //   this.error.splice(index,1);
    // },
    getRefundPrice() {
      productService.getRefundPrice().then((response) => {
        this.prices = response.data.result;
      });
    },
    editSubProduct() {
      this.$v.typeform.$touch();
      if (this.$v.typeform.$invalid) {
        setTimeout(() => {
          $("html, body").animate(
            {
              scrollTop:
                $(".is-invalid:first").offset().top -
                $("#page-topbar").height() -
                50,
            },
            200,
            function () {
              $(".is-invalid:first").focus();
            }
          );
        }, 300);
        return;
      } else {
        if (this.typeform.attributes.size === "") {
          error_message("Please Select Attribute");
        } else {
          var error = false;
          this.error.forEach((ele) => {
            if (ele == true) {
              error = true;
              alert("Please select different customer");
              return;
            }
          });
          if (error) {
            return false;
          }
          this.isDisabled = true;
          // this.typeform.attributes.size = this.typeform.attributes.size.id;
          // this.typeform.attributes.material = this.typeform.attributes.material.id;
          productService
            .editSubProduct({
              ...this.typeform,
              datetime: this.typeform.datetime,
            })
            .then((response) => {
              if (response.data.code === 200) {
                this.$router.push({
                  name: "sub-product-list",
                  params: { product_id: this.base64(this.typeform.product_id) },
                });
                success_message(response.data.message);
              } else {
                error_message(response.data.message);
              }
              this.isDisabled = false;
            });
        }
      }
    },
    someHandler(event) {
      this.item_vat = (event.target.value * this.product_vat) / 100;
      this.typeform.sale_price = (
        Number(event.target.value) + Number(this.item_vat)
      ).toFixed(this.decimal);
      this.perUnitPriceCal("private");
    },
    calFullRefundPrice(){
      var qty = (this.typeform.selling_qty != '') ?this.typeform.selling_qty: 0;
      var boxPrice = (this.typeform.product_box_type != '')?this.typeform.product_box_type['price']:0;
      var bottlePrice = (this.typeform.single_refund_price != '')?this.typeform.single_refund_price['att_name']:0;
      
      if(bottlePrice != ''){
       this.typeform.refund_price =((Number(bottlePrice) * qty) + Number(boxPrice)).toFixed(this.decimal);
      }
    },
    priceHandler(event) {
      this.item_vat = (event.target.value * this.product_vat) / 100;
      this.typeform.business_sale_price = (
        Number(event.target.value) + Number(this.item_vat)
      ).toFixed(this.decimal);
      this.perUnitPriceCal("business");
    },
    changePerUnitPrice(type) {
      if(type == ""){
        this.calFullRefundPrice();
      }
      if (type != "material") {
        this.perUnitPriceCal("private");
        this.perUnitPriceCal("business");
      }
    },
    perUnitPriceCal(userType) {
      let productPrice =
        userType == "private"
          ? this.typeform.sale_price
          : this.typeform.business_sale_price;

      let sizeVal = 1;
      let sizeUnit = this.product_unit_sign;

      if (
        this.typeform.attributes.size != "" &&
        this.typeform.attributes.size != null
      ) {
        let attr = findUserById(
          this.attrName.size,
          this.typeform.attributes.size.id
        );

        let size = attr.att_name;
        let result = size.match(/ml|l|kg|g/gi);

        const myArray = size.split(result[0], 1);
        sizeVal = myArray[0].replace(",", ".");
        sizeUnit = result[0];
      }

      let perUnitPrice;
      perUnitPrice = convertUnits(
        productPrice,
        sizeUnit,
        this.product_unit_sign,
        sizeVal,
        this.typeform.selling_qty
      ).toFixed(this.decimal);

      if (userType == "private") {
        this.typeform.per_unit_price = perUnitPrice ?? null;
      } else {
        this.typeform.per_unit_price_business = perUnitPrice ?? null;
      }

      if (this.typeform.is_discount == 1) {
        let disPerUnitPrice;
        let disProductPrice =
          userType == "private"
            ? this.typeform.dis_price
            : this.typeform.business_dis_price;
        disPerUnitPrice = convertUnits(
          disProductPrice,
          sizeUnit,
          this.product_unit_sign,
          sizeVal,
          this.typeform.selling_qty
        ).toFixed(this.decimal);

        if (userType == "private") {
          this.typeform.per_unit_dis_price = disPerUnitPrice ?? null;
        } else {
          this.typeform.per_unit_dis_price_business = disPerUnitPrice ?? null;
        }
      }
    },
  },
};
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-12">
        <div
          class="
            page-title-box
            d-flex
            align-items-center
            justify-content-between
            icon-main-page
          "
        >
          <div class="page-title-left avatar-main-icon">
            <div class="avatar-xs mr-3">
              <span
                class="
                  avatar-title
                  rounded-circle
                  bg-soft-primary
                  text-primary
                  font-size-18
                "
              >
                <i class="bx bx-briefcase"></i>
              </span>
            </div>
            <div class="report-tag">
              <h4 class="mb-0 font-size-18">{{ typeform.barcode_number }}</h4>
              <p>
                <router-link
                  :to="{
                    name: 'sub-product-list',
                    params: { product_id: base64(typeform.product_id) },
                  }"
                  >{{ trans.get("__JSON__.Sub Products") }}</router-link
                >
                > {{ typeform.barcode_number }}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <form @submit.prevent="editSubProduct">
          <div class="card">
            <div class="card-body">
              <p class="card-title-desc"></p>
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Barcode Number")
                    }}</label>
                    <input
                      maxlength="13"
                      minlength="8"
                      id="barcode_number"
                      v-model="$v.typeform.barcode_number.$model"
                      type="text"
                      class="form-control"
                      :placeholder="trans.trans('__JSON__.Barcode Number')"
                      name="barcode_number"
                      @keypress="contactNumber($event)"
                      :class="{
                        'is-invalid': $v.typeform.barcode_number.$error,
                      }"
                      autocomplete="off"
                    />
                    <div
                      v-if="$v.typeform.barcode_number.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.barcode_number.required">{{
                        trans.get("__JSON__.Please enter barcode number")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Product Number")
                    }}</label>
                    <input
                      maxlength="13"
                      minlength="8"
                      id="product_number"
                      v-model="$v.typeform.product_number.$model"
                      type="text"
                      class="form-control"
                      :placeholder="trans.trans('__JSON__.Product Number')"
                      name="product_number"
                      @keypress="contactNumber($event)"
                      :class="{
                        'is-invalid': $v.typeform.product_number.$error,
                      }"
                      autocomplete="off"
                    />
                    <div
                      v-if="$v.typeform.product_number.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.product_number.required">{{
                        trans.get("__JSON__.Please enter product number")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label>{{ trans.trans("__JSON__.Product Tag") }}</label>
                    <select
                      class="custom-select"
                      v-model="typeform.tag_id"
                      id="tag_id"
                      name="tag_id"
                    >
                      <option value="0">
                        {{ trans.get("__JSON__.Select Product Tag") }}
                      </option>
                      <option v-for="tag in tags" :value="tag.id" :key="tag.id">
                        {{ tag.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Quantity")
                    }}</label>
                    <input
                      maxlength="4"
                      minlength="1"
                      id="quantity"
                      v-model="$v.typeform.quantity.$model"
                      type="text"
                      class="form-control"
                      :placeholder="trans.trans('__JSON__.Quantity')"
                      name="quantity"
                      @keypress="contactNumber($event)"
                      :class="{ 'is-invalid': $v.typeform.quantity.$error }"
                    />
                    <div
                      v-if="$v.typeform.quantity.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.quantity.required">{{
                        trans.get("__JSON__.Please enter quantity")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Product Type")
                    }}</label>
                    <select
                      class="custom-select"
                      v-model="typeform.product_type"
                      id="product_type"
                      name="product_type"
                      @change="onItemChange()"
                      :class="{ 'is-invalid': $v.typeform.product_type.$error }"
                    >
                      <option value="">
                        {{ trans.get("__JSON__.Select Product Type") }}
                      </option>
                      <option value="1">{{ trans.get("__JSON__.Box") }}</option>
                      <option value="0">
                        {{ trans.get("__JSON__.Single Item") }}
                      </option>
                      
                    </select>
                    <div
                      v-if="$v.typeform.product_type.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.product_type.required">{{
                        trans.get("__JSON__.Please select product type")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4" v-if="this.item_type == 1">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Selling Quantity")
                    }}</label>
                    <input
                      maxlength="4"
                      minlength="1"
                      id="selling_qty"
                      v-model="$v.typeform.selling_qty.$model"
                      type="text"
                      class="form-control"
                      :placeholder="trans.trans('__JSON__.Selling Quantity')"
                      name="selling_qty"
                      @keypress="contactNumber($event)"
                      @input="changePerUnitPrice('')"
                      :class="{ 'is-invalid': $v.typeform.selling_qty.$error }"
                    />
                    <div
                      v-if="$v.typeform.selling_qty.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.selling_qty.required">{{
                        trans.get("__JSON__.Please enter selling quantity")
                      }}</span>
                    </div>
                  </div>
                </div>

                <!-- <div
                  class="col-sm-4"
                  v-if="this.item_type == 1 && this.item_type != ''"
                >
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Single Product Price")
                    }}</label>
                    <input
                      maxlength="5"
                      minlength="1"
                      id="single_product_price"
                      v-model="$v.typeform.single_product_price.$model"
                      type="text"
                      class="form-control"
                      :placeholder="
                        trans.trans('__JSON__.Single Product Price')
                      "
                      name="single_product_price"
                      @keypress="
                        floatingNumber($event, typeform.single_product_price)
                      "
                      :class="{
                        'is-invalid': $v.typeform.single_product_price.$error,
                      }"
                    />
                    <div
                      v-if="$v.typeform.single_product_price.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.single_product_price.required">{{
                        trans.get("__JSON__.Please enter single product price")
                      }}</span>
                    </div>
                  </div>
                </div> -->

                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Private Price (Excluding Vat)")
                    }}</label>
                    <input
                      id="price"
                      v-model="$v.typeform.price.$model"
                      type="text"
                      class="form-control"
                      :placeholder="
                        trans.trans('__JSON__.Private Price (Excluding Vat)')
                      "
                      name="price"
                      :class="{ 'is-invalid': $v.typeform.price.$error }"
                      @input="validatePrivatePrice(typeform.price)"
                      v-on:keyup="someHandler($event)"
                    />
                    <div
                      v-if="$v.typeform.price.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.price.required">{{
                        trans.get("__JSON__.Please enter private price")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans(
                        "__JSON__.Private Selling Price (Including Vat)"
                      )
                    }}</label>
                    <input
                      maxlength="5"
                      minlength="1"
                      id="sale_price"
                      v-model="$v.typeform.sale_price.$model"
                      type="text"
                      class="form-control"
                      :placeholder="
                        trans.trans('__JSON__.Private Selling Price')
                      "
                      name="sale_price"
                      :class="{ 'is-invalid': $v.typeform.sale_price.$error }"
                      v-on:keypress="
                        floatingNumber($event, typeform.sale_price)
                      "
                      disabled
                    />
                    <div
                      v-if="$v.typeform.sale_price.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.sale_price.required">{{
                        trans.get("__JSON__.Please enter private price")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Per Unit Price Private")
                    }}</label>
                    <input
                      maxlength="5"
                      minlength="1"
                      id="per_unit_price"
                      v-model="$v.typeform.per_unit_price.$model"
                      type="text"
                      class="form-control"
                      :placeholder="
                        trans.trans('__JSON__.Per Unit Price Private')
                      "
                      name="per_unit_price"
                      v-on:keypress="
                        floatingNumber($event, typeform.per_unit_price)
                      "
                      :class="{
                        'is-invalid': $v.typeform.per_unit_price.$error,
                      }"
                      disabled
                    />
                    <div
                      v-if="$v.typeform.per_unit_price.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.per_unit_price.required">{{
                        trans.get("__JSON__.Please enter per unit price")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Business Price (Excluding Vat)")
                    }}</label>
                    <input
                      id="business_customer_price"
                      v-model="$v.typeform.business_customer_price.$model"
                      type="text"
                      class="form-control"
                      :placeholder="
                        trans.trans('__JSON__.Business Price (Excluding Vat)')
                      "
                      name="business_customer_price"
                      :class="{
                        'is-invalid':
                          $v.typeform.business_customer_price.$error,
                      }"
                      @input="
                      validateBusinessPrice(typeform.business_customer_price)
                      "
                      v-on:keyup="priceHandler($event)"
                    />
                    <div
                      v-if="$v.typeform.business_customer_price.$error"
                      class="invalid-feedback"
                    >
                      <span
                        v-if="!$v.typeform.business_customer_price.required"
                        >{{
                          trans.get("__JSON__.Please enter business price")
                        }}</span
                      >
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans(
                        "__JSON__.Business Selling Price (Including Vat)"
                      )
                    }}</label>
                    <input
                      maxlength="5"
                      minlength="1"
                      id="business_sale_price"
                      v-model="$v.typeform.business_sale_price.$model"
                      type="text"
                      class="form-control"
                      :placeholder="
                        trans.trans('__JSON__.Business Selling Price')
                      "
                      name="business_sale_price"
                      :class="{
                        'is-invalid': $v.typeform.business_sale_price.$error,
                      }"
                      v-on:keypress="
                        floatingNumber($event, typeform.business_sale_price)
                      "
                      disabled
                    />
                    <div
                      v-if="$v.typeform.business_sale_price.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.business_sale_price.required">{{
                        trans.get("__JSON__.Please enter business price")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Per Unit Price business")
                    }}</label>
                    <input
                      maxlength="5"
                      minlength="1"
                      id="per_unit_price_business"
                      v-model="$v.typeform.per_unit_price_business.$model"
                      type="text"
                      class="form-control"
                      :placeholder="
                        trans.trans('__JSON__.Per Unit Price business')
                      "
                      name="per_unit_price_business"
                      v-on:keypress="
                        floatingNumber($event, typeform.per_unit_price_business)
                      "
                      :class="{
                        'is-invalid':
                          $v.typeform.per_unit_price_business.$error,
                      }"
                      disabled
                    />
                    <div
                      v-if="$v.typeform.per_unit_price_business.$error"
                      class="invalid-feedback"
                    >
                      <span
                        v-if="!$v.typeform.per_unit_price_business.required"
                        >{{
                          trans.get("__JSON__.Please enter per unit price")
                        }}</span
                      >
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label>{{ trans.trans("__JSON__.Material Type") }}</label>
                    <select
                      name="is_reusable"
                      class="custom-select"
                      id="is_reusable"
                      v-model="typeform.is_reusable"
                      @change="onTypeChange()"
                    >
                      <option value="">
                        {{ trans.get("__JSON__.Select Material Type") }}
                      </option>
                      <option value="0">Einweg</option>
                      <option value="1">Mehrweg</option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-4" v-if="item_type == 1">
                  <div class="form-group">
                    <label>{{
                      trans.trans("__JSON__.Product Box Type")
                    }}</label>
                    <multiselect
                      v-model="typeform.product_box_type"
                      label="title"
                      track-by="id"
                      :placeholder="
                        trans.get('__JSON__.Select Product Box type')
                      "
                      open-direction="bottom"
                      :options="boxes"
                      :multiple="false"
                      :searchable="true"
                      :internal-search="true"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :max-height="600"
                      :show-no-results="true"
                      :hide-selected="true"
                      @input="calFullRefundPrice"
                      name="size"
                      :class="{
                        'is-invalid': $v.typeform.product_box_type.$error,
                      }"
                    >
                      <span slot="noResult"
                        >{{
                          trans.get(
                            "__JSON__.Oops! No elements found. Consider changing the search query"
                          )
                        }}.</span
                      >
                    </multiselect>
                    <!-- <div
                      v-if="$v.typeform.product_box_type.$error"
                      class="form-error"
                    >
                      <span v-if="!$v.typeform.product_box_type.required">{{
                        trans.get("__JSON__.Select Product Box type")
                      }}</span>
                    </div> -->
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label>{{ trans.trans("__JSON__.Single Bottle Refund Price") }}</label>
                      <multiselect
                      v-model="typeform.single_refund_price"
                      label="att_name"
                      track-by="id"
                      :placeholder="
                        trans.get('__JSON__.Select Single Bottle Refund Price')
                      "
                      open-direction="bottom"
                      :options="prices"
                      :multiple="false"
                      :searchable="true"
                      :internal-search="true"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :max-height="600"
                      :show-no-results="true"
                      :hide-selected="true"
                      name="single_refund_price"
                      @input="calFullRefundPrice"
                    >
                      <span slot="noResult"
                        >{{
                          trans.get(
                            "__JSON__.Oops! No elements found. Consider changing the search query"
                          )
                        }}.</span
                      >
                    </multiselect>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Full Box Refund Price")
                    }}</label>
                    <input
                      id="refund_price"
                      v-model="typeform.refund_price"
                      type="text"
                      class="form-control"
                      :placeholder="trans.trans('__JSON__.Full Box Refund Price')"
                      name="refund_price"
                      :readonly="true"
                    />
                  </div>
                </div>

                <!-- <div class="col-sm-4">
                  <div class="form-group">
                    <label>{{
                      trans.trans("__JSON__.Full Box Refund Price")
                    }}</label>
                    <select
                      class="custom-select"
                      v-model="typeform.refund_price"
                      id="refund_price"
                      name="refund_price"
                    >
                      <option value="">
                        {{ trans.get("__JSON__.Select Full Box Refund Price") }}
                      </option>
                      <option
                        v-for="price in prices"
                        :value="price.id"
                        :key="price.id"
                      >
                        {{ price.att_name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label>{{
                      trans.trans("__JSON__.Half Box Refund Price")
                    }}</label>
                    <select
                      class="custom-select"
                      v-model="typeform.half_refund_price"
                      id="half_refund_price"
                      name="half_refund_price"
                    >
                      <option value="">
                        {{ trans.get("__JSON__.Select Half Box Refund Price") }}
                      </option>
                      <option
                        v-for="price in prices"
                        :value="price.id"
                        :key="price.id"
                      >
                        {{ price.att_name }}
                      </option>
                    </select>
                  </div>
                </div> -->

                <!-- <div class="col-sm-4">
                  <div class="form-group">
                    <label>{{
                      trans.trans("__JSON__.Single Bottle Refund Price")
                    }}</label>
                    <select
                      class="custom-select"
                      v-model="typeform.single_refund_price"
                      id="single_refund_price"
                      name="single_refund_price"
                    >
                      <option value="">
                        {{
                          trans.get(
                            "__JSON__.Select Single Bottle Refund Price"
                          )
                        }}
                      </option>
                      <option
                        v-for="price in prices"
                        :value="price.id"
                        :key="price.id"
                      >
                        {{ price.att_name }}
                      </option>
                    </select>
                  </div>
                </div> -->

                <div class="col-sm-4 vendor-status">
                  <b-form-group
                    id="input-group-1"
                    :label="trans.get('__JSON__.Status')"
                    label-for="status"
                  >
                    <label class="switch">
                      <input
                        type="checkbox"
                        id="togBtn"
                        name="status"
                        v-model="typeform.status"
                        class="switch-on"
                        true-value="1"
                        false-value="0"
                      />
                      <div class="slider round">
                        <span class="on">{{
                          trans.get("__JSON__.Active")
                        }}</span>
                        <span class="off">{{
                          trans.get("__JSON__.Inactive")
                        }}</span>
                      </div>
                    </label>
                  </b-form-group>
                </div>

                <div class="col-sm-4">
                  <b-form-group
                    id="input-group-2"
                    :label="trans.get('__JSON__.Is Discount')"
                    label-for="Is Discount"
                  >
                    <div class="row">
                      <div class="col-sm-6">
                        <div class="swtich-data">
                          <label class="switch">
                            <input
                              type="checkbox"
                              id="togBtn"
                              class="switch-on"
                              name="is_discount"
                              v-model="typeform.is_discount"
                              true-value="1"
                              false-value="0"
                              @change="onDiscountChange()"
                            />
                            <div class="slider round">
                              <!--ADDED HTML -->
                              <span class="on">{{
                                trans.get("__JSON__.Yes")
                              }}</span>
                              <span class="off">{{
                                trans.get("__JSON__.No")
                              }}</span>
                              <!--END-->
                            </div>
                          </label>
                        </div>
                      </div>
                    </div>
                  </b-form-group>
                </div>

                <div class="col-sm-4" v-if="this.discount == 1">
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Customer Discount Type")
                    }}</label>
                    <select
                      name="customer_dis_type"
                      class="custom-select"
                      id="customer_dis_type"
                      v-model="$v.typeform.customer_dis_type.$model"
                      :class="{
                        'is-invalid': $v.typeform.customer_dis_type.$error,
                      }"
                      @change="onRoleChange()"
                    >
                      <option value="">
                        {{
                          trans.get("__JSON__.Select Customer Discount Type")
                        }}
                      </option>
                      <option value="0" selected>Both</option>
                      <option value="1">Business</option>
                      <option value="2">Private</option>
                    </select>
                    <div
                      v-if="$v.typeform.customer_dis_type.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.customer_dis_type.required">{{
                        trans.get(
                          "__JSON__.Please select customer discount type"
                        )
                      }}</span>
                    </div>
                  </div>
                </div>

                <div
                  class="col-sm-4"
                  v-if="
                    this.discount == 1 &&
                    (this.discount_type == 2 || this.discount_type == 0)
                  "
                >
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Private Sale Price")
                    }}</label>
                    <input
                      id="dis_price"
                      v-model="$v.typeform.dis_price.$model"
                      type="text"
                      class="form-control"
                      :placeholder="trans.trans('__JSON__.Private Sale Price')"
                      name="dis_price"
                      :class="{ 'is-invalid': $v.typeform.dis_price.$error }"
                      @input="validatePrivateSalePrice(typeform.dis_price)"
                      v-on:keyup="perUnitPriceCal('private')"
                    />
                    <div
                      v-if="$v.typeform.dis_price.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.dis_price.required">{{
                        trans.get("__JSON__.Please enter private sale price")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div
                  class="col-sm-4"
                  v-if="
                    this.discount == 1 &&
                    (this.discount_type == 1 || this.discount_type == 0)
                  "
                >
                  <div class="form-group">
                    <label class="required">{{
                      trans.trans("__JSON__.Business Sale Price")
                    }}</label>
                    <input
                      id="business_dis_price"
                      v-model="$v.typeform.business_dis_price.$model"
                      type="text"
                      class="form-control"
                      :placeholder="trans.trans('__JSON__.Business Sale Price')"
                      name="business_dis_price"
                      :class="{
                        'is-invalid': $v.typeform.business_dis_price.$error,
                      }"
                      @input="
                      validateBusinessSalePrice(typeform.business_dis_price)
                      "
                      v-on:keyup="perUnitPriceCal('business')"
                    />
                    <div
                      v-if="$v.typeform.business_dis_price.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.business_dis_price.required">{{
                        trans.get("__JSON__.Please enter business sale price")
                      }}</span>
                    </div>
                  </div>
                </div>

                <div
                  class="col-sm-4"
                  v-if="
                    this.discount == 1 &&
                    (this.discount_type == 1 ||
                      this.discount_type == 0 ||
                      this.discount_type == 2)
                  "
                >
                  <div class="form-group">
                    <label class="control-label required">{{
                      trans.get("__JSON__.Discount start/end Period")
                    }}</label>
                    <br />
                    <date-picker
                      v-model="$v.typeform.datetime.$model"
                      :disabled-date="disabledBeforeTodayAndAfterAWeek"
                      type="datetime"
                      value-type="format"
                      :rangeSeparator="rangeSeparator"
                      placeholder="Select datetime range"
                      range
                      :show-time-panel="showTimeRangePanel"
                      @close="handleRangeClose"
                      :class="{ 'is-invalid': $v.typeform.datetime.$error }"
                    >
                      <template v-slot:footer>
                        <button
                          class="mx-btn mx-btn-text"
                          @click="toggleTimeRangePanel"
                        >
                          {{
                            showTimeRangePanel ? "select date" : "select time"
                          }}
                        </button>
                      </template>
                    </date-picker>
                    <div
                      v-if="$v.typeform.datetime.$error"
                      class="invalid-feedback"
                    >
                      <span v-if="!$v.typeform.datetime.required"
                        >{{ trans.get("__JSON__.Please select date") }}.</span
                      >
                    </div>
                  </div>
                </div>

                <div class="col-sm-4">
                  <div class="form-group">
                    <label class="control-label required">{{
                      trans.get("__JSON__.Sub Product Image")
                    }}</label>
                    <dropzone-popup
                      multiple
                      v-model="$v.typeform.image.$model"
                      id="image_name"
                      name="image_name"
                      acceptedFiles=".jpeg,.jpg,.png"
                      :editable-images="image_name.map((doc) => doc.image)"
                      :media-path="image_media_path + typeform.id + '/original'"
                      @image-deleted="this.onImagedeleted"
                      :custom-params="{ id: $route.params.id }"
                      :delete-path="image_delete_url"
                    />
                    <div
                      v-if="$v.typeform.image.$error"
                      class="invalid-feedback cuisine-img"
                    >
                      <span v-if="!$v.typeform.image.required"
                        >{{ trans.get("__JSON__.Please select image") }}.</span
                      >
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="card">
            <div class="card-body">
              <h4 class="card-title required">
                {{ trans.get("__JSON__.Product Attribute") }}
              </h4>
              <p class="card-title-desc"></p>
              <!-- <div class="row" v-for="(v, i) in Object.keys(attrName)" :key="i">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>{{ v }}</label>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <select
                      class="custom-select"
                      v-model="typeform.attributes[v]"
                      v-on:change="changePerUnitPrice(v)"
                    >
                      <option value="">
                        {{ trans.get("__JSON__.Select Attribute Value") }}
                      </option>
                      <option
                        v-for="cat in attrName[v]"
                        :value="cat.id"
                        :key="cat.id"
                      >
                        {{ cat.att_name }}
                      </option>
                    </select>
                  </div>
                  {{typeform.attributes['size']}}
                  <div v-if="$v.typeform.attributes.size.$error" class="form-error">
                    <span v-if="$v.typeform.attributes.size.required">{{
                      trans.get("__JSON__.Select Attribute Value")
                    }}</span>
                  </div>
                </div>
              </div> -->
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>{{ trans.get("__JSON__.Material") }}</label>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <multiselect
                      v-model="$v.typeform.attributes.material.$model"
                      label="att_name"
                      track-by="id"
                      :placeholder="
                        trans.get('__JSON__.Select Attribute Value')
                      "
                      open-direction="bottom"
                      :options="attrName.material"
                      :multiple="false"
                      :searchable="true"
                      :internal-search="true"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :max-height="600"
                      :show-no-results="true"
                      :hide-selected="true"
                      name="material"
                      :class="{
                        'is-invalid': $v.typeform.attributes.material.$error,
                      }"
                    >
                      <span slot="noResult"
                        >{{
                          trans.get(
                            "__JSON__.Oops! No elements found. Consider changing the search query"
                          )
                        }}.</span
                      >
                    </multiselect>
                    <div
                      v-if="$v.typeform.attributes.material.$error"
                      class="form-error"
                    >
                      <span v-if="!$v.typeform.attributes.material.required">{{
                        trans.get("__JSON__.Select Attribute Value")
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>{{ trans.get("__JSON__.Size") }}</label>
                  </div>
                </div>
                <div class="col-sm-4">
                  <div class="form-group">
                    <multiselect
                      v-model="$v.typeform.attributes.size.$model"
                      label="att_name"
                      track-by="id"
                      :placeholder="
                        trans.get('__JSON__.Select Attribute Value')
                      "
                      open-direction="bottom"
                      :options="attrName.size"
                      :multiple="false"
                      :searchable="true"
                      :internal-search="true"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :max-height="600"
                      :show-no-results="true"
                      :hide-selected="true"
                      name="size"
                      :class="{
                        'is-invalid': $v.typeform.attributes.size.$error,
                      }"
                      @input="changePerUnitPrice('size')"
                    >
                      <span slot="noResult"
                        >{{
                          trans.get(
                            "__JSON__.Oops! No elements found. Consider changing the search query"
                          )
                        }}.</span
                      >
                    </multiselect>
                    <div
                      v-if="$v.typeform.attributes.size.$error"
                      class="form-error"
                    >
                      <span v-if="!$v.typeform.attributes.size.required">{{
                        trans.get("__JSON__.Select Attribute Value")
                      }}</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <button class="btn btn-primary mr-1 mt-3" :disabled="isDisabled">
                    {{ trans.get("__JSON__.Update") }}
                  </button>
                  <!-- <b-button
                    @click="$router.go(-1)"
                    type="button"
                    variant="secondary"
                    class="mt-3"
                    >{{ trans.get("__JSON__.Cancel") }}</b-button
                  > -->
                  <router-link
                    :to="{ name:'sub-product-list', params: {product_id:base64(this.typeform.product_id)} }"
                  >
                    <b-button
                      type="button"
                      variant="secondary"
                      class="mt-3"
                      >{{ trans.get("__JSON__.Cancel") }}</b-button
                    >
                  </router-link>
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="card">
            <div class="card-body">
              <h4 class="card-title">
                {{ trans.get("__JSON__.B2B Prices") }}
              </h4>
              <div
                class="row"
                v-for="(v, i) in $v.typeform.b2b_customers.$each.$iter"
                :key="i"
              >
                <div class="col-sm-4">
                  <div class="form-group">
                    <label>{{ trans.trans("__JSON__.Customer") }}</label>
                    <multiselect
                      v-model="v.customer.$model"
                      label="name"
                      track-by="user_id"
                      :placeholder="
                        trans.get('__JSON__.Type to Search Customer')
                      "
                      open-direction="bottom"
                      :options="customers"
                      :multiple="false"
                      :searchable="true"
                      :internal-search="true"
                      :close-on-select="true"
                      :clear-on-select="true"
                      :max-height="600"
                      :show-no-results="true"
                      :hide-selected="true"
                      name="customers[]"
                      :class="{
                        'is-invalid': v.customer.$error,
                      }"
                      @select="checkCustomer($event, i)"
                    >
                      <span slot="noResult"
                        >{{
                          trans.get(
                            "__JSON__.Oops! No elements found. Consider changing the search query"
                          )
                        }}.</span
                      >
                    </multiselect>
                    <div v-if="error[i] == true">
                      <span class="error-msg">{{
                        trans.get("__JSON__.This customer already selected")
                      }}</span>
                    </div>
                    <div v-if="v.customer.$error" class="form-error">
                      <span v-if="!v.customer.required">{{
                        trans.get("__JSON__.Please select customer")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label>{{ trans.trans("__JSON__.Min. Quantity") }}</label>
                    <input
                      maxlength="5"
                      minlength="1"
                      v-model="v.min_qty.$model"
                      type="text"
                      class="form-control"
                      :placeholder="trans.trans('__JSON__.Min. Quantity')"
                      name="min_qty[]"
                      :class="{
                        'is-invalid': v.min_qty.$error,
                      }"
                      @keypress="NotZeroNumber($event, 5)"
                    />
                    <div v-if="v.min_qty.$error" class="form-error">
                      <span v-if="!v.min_qty.required">{{
                        trans.get("__JSON__.Please add quantity")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-sm-2">
                  <div class="form-group">
                    <label>{{ trans.trans("__JSON__.Price") }}</label>
                    <input
                      maxlength="8"
                      minlength="1"
                      v-model="v.price.$model"
                      type="text"
                      class="form-control"
                      :placeholder="trans.trans('__JSON__.Price')"
                      name="price[]"
                      :class="{
                        'is-invalid': v.price.$error,
                      }"
                      @keypress="decimalNumber"
                    />
                    <div v-if="v.price.$error" class="form-error">
                      <span v-if="!v.price.required">{{
                        trans.get("__JSON__.Please add price")
                      }}</span>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <h6>&nbsp;</h6>
                  <button
                    class="btn btn-primary btn-sm btn-rounded"
                    @click.prevent="AddField()"
                  >
                    +</button
                  >&nbsp;&nbsp;
                  <button
                    class="btn btn-danger btn-sm btn-rounded"
                    v-if="i != 0"
                    @click.prevent="remove_field(i)"
                  >
                    -
                  </button>
                </div>
              </div>
              <div class="row">
                <div class="col-sm-6">
                  <button class="btn btn-primary mr-1 mt-3" :disabled="isDisabled">
                    {{ trans.get("__JSON__.Update") }}
                  </button> -->
                  <!-- <b-button
                    @click="$router.go(-1)"
                    type="button"
                    variant="secondary"
                    class="mt-3"
                    >{{ trans.get("__JSON__.Cancel") }}</b-button
                  > -->
                  <!-- <router-link
                    :to="{ name:'sub-product-list', params: {product_id:base64(this.typeform.product_id)} }"
                  >
                    <b-button
                      type="button"
                      variant="secondary"
                      class="mt-3"
                      >{{ trans.get("__JSON__.Cancel") }}</b-button
                    >
                  </router-link>
                </div>
              </div>
            </div>
          </div> -->
        </form>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>
<style scoped>
.barcode .vendor-img {
  border-radius: 15% !important;
  height: 120px;
  width: 120px;
}
.is-invalid .mx-input {
  border-color: #f46a6a !important;
}
</style>